module.exports = __webpack_public_path__ + "static/Elena-db145f4cfc40dcdefa21f98cc45901f5.png";